export default __webpack_public_path__ + "static/media/sticker-M.c4e66e9a.png";